import { LevelSpec } from '../game/LevelSpec';
import { Fridge } from '../game/objects/Fridge';
import { Direction } from '../game/Direction';
import { Bench } from '../game/objects/Bench';
import { Drink } from '../game/objects/Drink';
import { ServingSpot } from '../game/objects/ServingSpot';
export default new LevelSpec({
    title: 'First Service',
    goal: 'Grab a <keyword type="food">drink</keyword> from the <keyword>fridge</keyword> and take it to the <keyword type="conveyor">conveyor belt</keyword> to serve it.',
    testGoal: (world) => {
        if (world.served.some(obj => obj instanceof Drink)) {
            return { win: true };
        }
    },
    helpText: `
		<p>
			Move <keyword type="robot">Red</keyword> to the fridge, and then use the
			<code>red.grab()</code> method to pick up a drink. Then move your robot to the
			conveyor belt and use the <code>red.drop()</code> method to place the drink on the belt.
		</p>

		<p>
			You can also add <b>comments</b> to your code by using the <code>#</code> symbol. Python
			will ignore anything you write after <code>#</code>, allowing you to write notes for
			your own reference.
		</p>
	`,
    lockedLines: 3,
    defaultCode: `
		from kitchen import *

		red = robots.get( 'red' )
		
		# Walk to the fridge.
		red.turn_right()
	
		# Grab a drink.
	`,
    layout: [
        'dbfbb',
        '.....',
        '...r.',
        '.....',
    ],
    spawners: {
        d: (map, pos) => [new ServingSpot(map, pos, Direction.South)],
        b: (map, pos) => [new Bench(map, pos, Direction.South)],
        f: (map, pos) => [new Fridge(map, pos, Drink)],
    }
});
